import { render, staticRenderFns } from "./SectorPrimerCard.vue?vue&type=template&id=29eba942&scoped=true&"
import script from "./SectorPrimerCard.vue?vue&type=script&lang=js&"
export * from "./SectorPrimerCard.vue?vue&type=script&lang=js&"
import style0 from "./SectorPrimerCard.vue?vue&type=style&index=0&id=29eba942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eba942",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VImg,VListItemAvatar})
